/**
 * Конфиг для таблицы состава заказа в карточке заказа
 * @module PageOrders/orderDetailsTableConfig
 * */

export default [
  {
    title: 'Артикул',
    field: 'vendorCode',
    name: 'vendorCode',
    hidden: false,
    sortable: true,
    filterable: false,
    columnWidth: 'min-width: 180px; width: 12.5%'
  },
  {
    title: 'Название товара',
    field: 'productName',
    name: 'productName',
    hidden: false,
    sortable: true,
    filterable: true,
    columnWidth: 'min-width: 180px; width: 12.5%'
  },
  {
    title: 'Стоимость единицы товара',
    field: 'unitCost',
    name: 'unitCost',
    hidden: false,
    sortable: true,
    filterable: true,
    columnWidth: 'min-width: 180px; width: 12.5%'
  },
  {
    title: 'Стоимость товара в чеке',
    field: 'checkCost',
    name: 'checkCost',
    hidden: false,
    sortable: true,
    filterable: false,
    columnWidth: 'min-width: 160px; width: 12.5%'
  },
  {
    title: 'Количество заказанного товара клиентом',
    field: 'orderedQuantity',
    name: 'orderedQuantity',
    hidden: false,
    sortable: true,
    filterable: false,
    columnWidth: 'min-width: 180px; width: 12.5%'
  },
  {
    title: 'Отобрано заказов',
    field: 'selectedOrders',
    name: 'selectedOrders',
    hidden: false,
    sortable: true,
    filterable: false,
    columnWidth: 'min-width: 180px; width: 12.5%'
  },
  {
    title: 'Нет в наличии',
    field: 'notAvailable',
    name: 'notAvailable',
    hidden: false,
    sortable: true,
    filterable: false,
    format: val => (val ? 'Нет в наличии' : 'Есть'),
    columnWidth: 'min-width: 180px; width: 12.5%'
  },
  {
    title: 'Замена',
    field: 'replacement',
    name: 'replacement',
    hidden: false,
    sortable: true,
    filterable: false,
    columnWidth: 'min-width: 180px; width: 12.5%'
  }
]
